import React from 'react';
import './ShareModal.css'; 
import { medalMap } from './utils';

const failedLevelMark = '❌'; 

function ShareModal({ open, onClose, summaryBlocks, levelsCleared, totalMaxGuesses, clipboardMessage }) {
  if (!open) return null;

  return (
    <div className="modal-overlay">
      <div className="share-modal-content">
        <button className="modal-close" onClick={onClose} aria-label="Close">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24"
            viewBox="0 0 24 24"
            width="24"
            fill="currentColor"
          >
            <path d="M0 0h24v24H0V0z" fill="none" />
            <path d="M18.3 5.71a1 1 0 00-1.41 0L12 10.59 7.11 5.7A1 1 0 105.7 7.11L10.59 12l-4.89 4.89a1 1 0 101.41 1.41L12 13.41l4.89 4.89a1 1 0 001.41-1.41L13.41 12l4.89-4.89a1 1 0 000-1.4z" />
          </svg>
        </button>
        <h2>Crackle Summary</h2>
  
        {/* Score Line */}
        <div className="score-line">
          {levelsCleared === summaryBlocks.length 
            ? `✅ Crackle: ${summaryBlocks.reduce((acc, block) => acc + block.split('\n').length, 0)}/${totalMaxGuesses}`
            : `❌ Crackle: ${summaryBlocks.reduce((acc, block) => acc + block.split('\n').length, 0)}/${totalMaxGuesses}`
          }
        </div>
  
        {/* Blocks */}
        {summaryBlocks.map((block, index) => (
          <div key={index} className="share-block">
            <pre className="guess-block">{block}</pre>
            <div className="medal-big">
              {index < levelsCleared ? medalMap[index] : <span className="X-big">{failedLevelMark}</span>}
            </div>
          </div>
        ))}
        {clipboardMessage && (
          <div className="clipboard-status">
            {clipboardMessage}
          </div>
        )}
      </div>
    </div>
  );
}  

export default ShareModal;
